<template>
  <div class="Modal-mask">
    <div
      v-click-outside="handleCloseScreenSelectionMenu"
      class="ScreenNavigationMenu"
    >
      <div class="u-flex u-flex-alignCenter u-flex-spaceBetween">
        <h2 class="Title">
          Screens
        </h2>
        <span
          class="Icon Icon-times"
          @click="handleCloseScreenSelectionMenu"
        />
      </div>
      <hr>
      <ul>
        <draggable
          v-model="screenOrder"
          @change="handleMove"
        >
          <li
            v-for="numberedScreen in screens"
            :key="numberedScreen.number"
          >
            <div
              class="ScreenNavigationMenu-item u-flex u-flex-alignCenter"
              @click="handleSelectScreen(numberedScreen.number)"
            >
              <template v-if="numberedScreen.questionVuexId">
                <span
                  class="Icon-s Icon-user"
                />
                <span class="QuestionLabel">
                  <span
                    class="QuestionLabel-content"
                    v-html="getTypeLabel(numberedScreen.questionVuexId)"
                  /></span>
              </template>
              <template v-else>
                <span
                  class="Icon-s Icon-exclamation"
                /><span>Empty Screen </span>
              </template>
            </div>
          </li>
        </draggable>
      </ul>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import {
  mapState, mapMutations, mapGetters, mapActions,
} from 'vuex';

export default {
  name: 'ScreenNavigationMenu',

  components: {
    Draggable,
  },

  computed: {
    ...mapState('forms', {
      screens: (state) => state.screens,
      logicWarningsShown: (state) => state.logicWarningsShown,
    }),
    ...mapGetters('forms', [
      'dynamicFormQuestionList',
      'getStatementsFromForm',
      'getFormQuestionsWithoutStatements',
    ]),

    screenOrder: {
      get() {
        return this.screens;
      },
      set(screens) {
        this.reorderDynamicFormScreens(screens);
      },
    },
  },
  methods: {
    ...mapActions('forms', [
      'reorderDynamicFormScreens',
    ]),
    ...mapMutations('forms', [
      'setCurrentScreenNumber',
      'updateLogicWarnings',
    ]),

    handleMove({ moved }) {
      const id = moved.element.questionVuexId;

      if (!this.logicWarningsShown.reorderQuestions && (this.dynamicFormQuestionList[id].has_flows || this.dynamicFormQuestionList[id].has_scores)) {
        this.$bus.$emit('displayMsg', {
          text: 'Reordering screens can change screen flows and scores already set up for this form. Please check them again in the Logic tab',
          type: 'warning',
          duration: 8000,
        });
        this.updateLogicWarnings('reorderQuestions');
      }
    },
    getTypeLabel(vuexId) {
      const question = this.dynamicFormQuestionList[vuexId];
      if (question === undefined) return null;
      if (question.type === 'statement') {
        return `S${this.getStatementsFromForm.findIndex((item) => item.vuexId === question.vuexId) + 1} - ${question.label}`;
      }

      return `Q${this.getFormQuestionsWithoutStatements.findIndex((item) => item.vuexId === question.vuexId) + 1} - ${question.label}`;
    },
    handleCloseScreenSelectionMenu() {
      this.$emit('screen-selection-menu:close');
    },
    handleSelectScreen(number) {
      this.setCurrentScreenNumber(number);
      this.handleCloseScreenSelectionMenu();
    },
  },
};
</script>

<style scoped lang="scss">
.Modal-mask {
  z-index: 10001;
}
.ScreenNavigationMenu {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 99999;
  height: 100vh;
  width: 265px;
  border-radius: 6px;
  overflow-y: auto;
  background: white;
  border: 1px solid lightgrey;

  .Title {
    margin-bottom: 0;
    padding: 12px 0 0 16px;
  }

  .Icon-times {
    margin: 5px 16px 0 0;
    font-size: 1.2rem;
    cursor: pointer;
  }

  hr {
    margin: 15px 0 8px 0;
  }

  .sortable-chosen {
    border: 1px solid #396dd5 !important;
    border-radius: 5px;
  }

  .sortable-ghost {
    box-shadow: none;
    padding: 2px;
    border-radius: 5px;
    border: 2px dotted #888888 !important;
    background: transparent;
  }

  ul {
    margin: 0;
    padding-left: 6px;
  }

  li {

    &:hover {
      background-color: #EEF1F3;
    }

    .ScreenNavigationMenu-item {
      cursor: pointer;
      padding: 10px;
      word-break: break-word;
      overflow: hidden;
      font-size: 0.9rem;

      .Icon-s {
        background: #e0e4ea;
        font-size: 16px;
        border: 1px solid #d0d7e1;
        padding: 6px 11px;
        align-self: baseline;
        border-radius: 10px;
        margin-right: 10px;
      }

      .QuestionLabel {
        align-self: flex-start;
        height: 38px;
        overflow: hidden;
      }

     ::v-deep .QuestionLabel-content {

        p, a, h1, h2, h3, h4, h5, h6 {
          display: inline;
          line-height: 1;
          color: inherit;
          font-size: inherit;
        }
      }

      .Icon-exclamation {
        color: red;
      }
    }
  }
}
</style>
